import React, { SFC, ReactElement } from 'react';
import styled from 'styled-components';
import useTranslator from '../../hooks/useTranslator';
import useCookiePolicy from '../../hooks/flags/useCookiePolicy';
import useConfig from '../../hooks/useConfig';

const StyledCookieBar = styled.div`
    position: fixed;
    bottom: 0;
    padding: 10px 40px 10px 10px;
    background: #f2f1ed;
    z-index: 90;
    width: 100%;
`;

const StyledCookieBarText = styled.div`
    font-size: 0.8em;
    color: ${({ theme }) => theme.colors.charcoal60};
`;

const StyledCookieLink = styled.a`
    margin-left: 10px;
    color: ${({ theme }) => theme.colors.turquoise100};
`;

const StyledCookieClose = styled.span`
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 50%;
    right: 10px;
    margin-top: -10px;
    transform: scale(0.8);
    cursor: pointer;
    color: ${({ theme }) => theme.colors.charcoal60};
    &:before {
        content: '';
        position: absolute;
        display: block;
        width: 23px;
        height: 27px;
        border: 1px solid transparent;
        border-left: 1px solid ${({ theme }) => theme.colors.charcoal60};
        transform: rotate(45deg);
        top: 5px;
        left: 7px;
    }
    &:after {
        content: '';
        position: absolute;
        display: block;
        width: 27px;
        height: 27px;
        border: 0 none;
        border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal60};
        transform: rotate(45deg);
        top: -13px;
        right: -14px;
    }
`;

export const CookiePolicy: SFC = (): ReactElement | null => {
    const { shouldShow, acceptCookiePolicy } = useCookiePolicy();
    const t = useTranslator();
    const config = useConfig();
    return (
        <>
            {shouldShow && (
                <StyledCookieBar>
                    <StyledCookieBarText>
                        <span>
                            {t(
                                'We are constantly improving WestwingNow, and we also use cookies. With your visit, you agree with our cookie policy.'
                            )}
                        </span>
                        <StyledCookieLink href={config.links.dataProtection}>{t('Learn more')}</StyledCookieLink>
                    </StyledCookieBarText>
                    <StyledCookieClose onClick={acceptCookiePolicy} />
                </StyledCookieBar>
            )}
        </>
    );
};

export default CookiePolicy;
